export var SegmentType;
(function (SegmentType) {
    SegmentType["SEGMENT_TYPE_STRING"] = "STRING";
    SegmentType["SEGMENT_TYPE_WILDCARD"] = "WILDCARD";
    SegmentType["SEGMENT_TYPE_PARTITION"] = "PARTITION";
})(SegmentType || (SegmentType = {}));
